import SettingsToggle from "../common/settings-toggle";
import { useSettingsData } from "../../../../contexts/SettingsDataContext";
import { UserX } from "lucide-react-native";

const AllowAnonCalls = () => {
  const { settings, handleAllowAnonymousCalls, isTestCallActive } =
    useSettingsData();

  return (
    <SettingsToggle
      title="Allow anonymous calls"
      description="Anonymous callers cannot be reached for follow-up via phone or text message."
      value={settings.allowAnonymousCalls}
      onValueChange={handleAllowAnonymousCalls}
      icon={UserX}
      disabled={isTestCallActive}
    />
  );
};

export default AllowAnonCalls;
